import { INIT, SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';
import {
	ADD_GIFTCARD_REQUEST,
	ADD_GIFTCARD_ERROR,
	ADD_GIFTCARD_SUCCESS,
	CLEAR_GIFTCARD_BALANCE
} from 'actions/MyAccountActions/giftCardActions';

const defaultState = { asyncStatus: INIT };
export default function addGiftCard(state = defaultState, action = {}) {
	switch (action.type) {
		case ADD_GIFTCARD_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case ADD_GIFTCARD_SUCCESS:
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				data: action.data
			});
		case ADD_GIFTCARD_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		case CLEAR_GIFTCARD_BALANCE:
			return defaultState;
		default:
			return state;
	}
}
